import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import Loading from "../../components/Loading/Loading";
import { Grid } from '@mui/material';
import { getArticulosByCategory } from "../../services/ArticulosServices";
import { getCarritoByID } from "../../services/CarritoServices";
import { CategoryFilter } from '../../components/CategoryFilter/CategoryFilter';

//componente para productos
import { ProductList } from '../../components/ProductList/ProductList';
//componente para productos
import ControlsRow from '../../components/ControlsRows/ControlsRows';
// importar componentes para el pdf
import { pdf } from '@react-pdf/renderer';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ExportPdf from '../../components/pdf/exportPdf';
// importar datos de empresa
import { AuthContext } from "../../context/authContext";
import logoDefault from "../../images/productDefault.jpg";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const SearchResults = () => {

  // inyeccion
  const query = useQuery();
  const searchQuery = query.get('q');
  // datos de empresa 
  const { empresa = {}, user } = useContext(AuthContext);
  // estado par loading   
  const [loading, setLoading] = useState(true);
  // estado para productos de la busqueda de productos 
  const [ramosArray, setRamosArray] = useState([]);
  const [rubrosArray, setRubrosArray] = useState([]);
  const [subrubrosArray, setSubrubrosArray] = useState([]);
  const [products, setProducts] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  // Estado para productos de la busqueda de productos
  const [searchTerm, setSearchTerm] = useState(searchQuery);
  const [selectedRamo, setSelectedRamo] = useState('');
  const [selectedRubro, setSelectedRubro] = useState('');
  const [selectedSubrubro, setSelectedSubrubro] = useState('');
  const [selectedMarca, setSelectedMarca] = useState('');
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(42);
  const [orderBy, setOrderBy] = useState('');
  const [generandoPDF, setGenerandoPDF] = useState(false);
  // Estado para la vista
  const [viewMode, setViewMode] = useState('horizontal');

  useEffect(() => {
    if (empresa?.vista === false) {
      setViewMode('horizontal');
    } else {
      setViewMode('grid');
    }
  }, [empresa]);

  const getImageSrc = (producto) => {
    const imgArtPath = producto?.art_imagen?.trim();
    const imgEmpPath = empresa?.imagen_articulo?.trim();
    let imgPath; // Usamos let porque vamos a reasignar este valor
    if (imgArtPath) {
      imgPath = `${process.env.REACT_APP_URL_BACKEND}${imgArtPath}`;
    } else if (imgEmpPath) {
      imgPath = `${process.env.REACT_APP_URL_BACKEND}${imgEmpPath}`;
    } else {
      imgPath = logoDefault;
    }

    return imgPath;
  };

  const getArticulosData = async (
    searchTerm,
    selectedRamo,
    selectedRubro,
    selectedSubrubro,
    selectedMarca,
    currentPage,
    perPage,
    ordenamiento) => {
    setLoading(true);
    const clienteSelected = JSON.parse(localStorage.getItem('clienteSelected'));
    const idcli= user.rol_id === 1 ? user?.id : clienteSelected?.id; // Si el usuario es cliente, usamos su ID, si es admin, usamos el ID del cliente seleccionado
    const res = await getArticulosByCategory({
      searchTerm,
      ramoId: selectedRamo,
      rubroId: selectedRubro,
      subrubroId: selectedSubrubro,
      marcaId: selectedMarca,
      page: currentPage,
      perPage,
      user_id: idcli,
      orderBy: ordenamiento.orderBy,
      orden: ordenamiento.orden
    });
    if (res) {
      const mappedProducts = res.products.map(producto => {
        // Validamos si producto.stock es un número válido
        const stockFormatted = (producto?.stock != null)
          ? (Number.isInteger(producto.stock)
            ? producto.stock.toString()
            : producto.stock.toLocaleString('es-AR', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
              useGrouping: true
            }))
          : "0";  // Valor por defecto si stock es null o undefined

        // Validamos si precioVigente y precioMostrar existen antes de compararlos
        const hayOferta = (producto?.precioVigente != null && producto?.precioMostrar != null)
          ? producto.precioVigente !== producto.precioMostrar
          : false;

        // Disponibilidad según venta_sin_stock y oferta
        let availability = producto?.art_desclarga ?? "Sin descripción";  // Usamos "Sin descripción" por defecto
        let installment;

        // Texto según tipo de precio
        let textoPrecio;

        switch (producto?.tipoPrecioFinal) {
          case 2:
            textoPrecio = "Oferta";
            break;
          case 1:
            textoPrecio = "Lista";
            break;
          default:
            textoPrecio = "Disponible";
        }

        // ===============================
        // Lógica con stock
        // ===============================
        if (empresa?.venta_sin_stock === false) {
          if (producto?.stock > 0) {
            installment = `${textoPrecio}: ${stockFormatted} u`;
          } else {
            installment = "Sin Stock";
          }
        } else {
          installment = textoPrecio;
        }


        // Validamos precioMostrar para evitar errores en toLocaleString
        const price = (producto?.precioMostrar != null)
          ? "$" + producto.precioMostrar.toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
          : "Precio no disponible";

        // Validamos precioVigente para evitar errores en toLocaleString
        const priceOld = (producto?.precioVigente != null)
          ? "$" + producto.precioVigente.toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
          : null;

        // Validamos el porcentaje para evitar divisiones por cero
        const percentage = (producto?.precioVigente != null && producto?.precioMostrar != null && producto.precioVigente > 0)
          ? (((producto.precioVigente - producto.precioMostrar) / producto.precioVigente) * 100).toLocaleString('es-AR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          })
          : null;

        // Retorno final del producto mapeado
        return {
          id: producto.id,
          code: producto.art_codigo,
          category: producto?.Ramo?.descripcion_ramo ?? "Sin categoría",  // Valor por defecto si es null o undefined
          description: producto?.art_descripcion ?? "Sin descripción", // Valor por defecto si es null o undefined
          section: "TrendingProducts",
          imgSrc: getImageSrc(producto),
          altText: producto?.art_descripcion ?? "Sin descripción", // Valor por defecto si es null o undefined
          title: producto?.art_descripcion ?? "Sin título", // Valor por defecto si es null o undefined
          price,
          priceOld,
          percentage,
          stockActual: stockFormatted,
          installment,
          availability,
          rating: null,
          reviews: 580,  // Este valor lo puedes actualizar si tienes datos reales
        };
      });


      setProducts(mappedProducts);
      setTotalPages(res.pagination.totalPage);
      setTotalItems(res.pagination.totalItems);
    }
    setLoading(false);
  };

  const fetchAllProductsForPdf = async () => {
    try {
      const cliente = user;
      if (!cliente?.id) return []; // Asegúrate de que cliente exista

      // Solicitar solo 1 artículo para obtener el total de productos disponibles
      const previewResponse = await getArticulosByCategory(searchQuery, 1, 1, cliente.id);
      const totalItems = previewResponse?.pagination?.totalItems;

      if (!totalItems) return []; // Si no hay productos, regresa un array vacío

      // Ahora solicitamos todos los productos con el número total de artículos
      const fullResponse = await getArticulosByCategory(searchQuery, 1, totalItems, cliente.id);  // Aquí corregí el 1 por totalItems

      if (!fullResponse) return []; // Si no hay respuesta completa, regresa un array vacío

      // Mapear los productos para darles formato adecuado
      const mappedProducts = fullResponse.products.map(producto => {
        const stockFormatted = Number.isInteger(producto.stock)
          ? producto.stock.toString()
          : producto.stock.toLocaleString('es-AR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true
          });

        const hayOferta = producto?.precioVigente !== producto?.precioMostrar;

        let installment;
        if (empresa?.venta_sin_stock === false) {
          if (producto.stock > 0) {
            installment = hayOferta
              ? `Oferta: ${stockFormatted} u`
              : `Disponible: ${stockFormatted} u`;
          } else {
            installment = 'Sin Stock';
          }
        } else {
          installment = hayOferta ? 'Oferta' : 'Disponible';
        }

        return {
          id: producto.id,
          category: producto?.Ramo?.descripcion_ramo,
          description: producto.art_descripcion,
          section: 'TrendingProducts',
          imgSrc: getImageSrc(producto),
          altText: producto.art_descripcion,
          title: producto.art_descripcion,
          price: "$" + producto?.precioMostrar?.toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }),
          priceOld: "$" + producto?.precioVigente?.toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }),
          percentage: (((producto?.precioVigente - producto?.precioMostrar) / producto?.precioVigente) * 100).toLocaleString('es-AR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }),
          installment,
          availability: producto.art_desclarga,
          rating: null, // Asumiendo que esto se actualizará más tarde
          reviews: 580, // Este valor se puede actualizar si es necesario
        };
      });
      setProducts(mappedProducts); // Establece los productos mapeados en el estado

      return products; // Retorna los productos mapeados en caso de que se necesiten en otra parte
    } catch (error) {
      console.error('Error fetching products for PDF:', error);
      return []; // Devuelve un array vacío si ocurre un error
    }
  };

  const fetchCarrito = async () => {
    const idCarrito = localStorage.getItem('idCarrito');
    if (idCarrito) {
      try {
        const res = await getCarritoByID(idCarrito);
        if (res?.Carrito_items) {
          // Mapeamos los items para incluir tanto el cartId como el artId
          const map = res.Carrito_items.map(item => ({
            cartId: res.id,  // Asumimos que `res.id` es el cartId
            itemId: item.id,
            artId: item.art_Id  // artId es el identificador único del artículo
          }));
          setCartItems(map);
        }
      } catch (error) {
        console.error("Error al obtener el carrito:", error);
      }
    }
  };

  const getOrder = (orderBy) => {
    switch (orderBy) {
      case "precio_asc":
        return { orderBy: 'precioMostrar', orden: 'asc' }
      case "precio_desc":
        return { orderBy: 'precioMostrar', orden: 'desc' }
      case "nombre_asc":
        return { orderBy: 'art_descripcion', orden: 'asc' }
      case "nombre_desc":
        return { orderBy: 'art_descripcion', orden: 'desc' }
      case "codigo_asc":
        return { orderBy: 'art_codigo', orden: 'asc' }
      case "codigo_desc":
        return { orderBy: 'art_codigo', orden: 'desc' }
      default:
        return { orderBy: '', orden: '' }
    }
  }

  useEffect(() => {
    var ordenamiento = getOrder(orderBy);
    getArticulosData(searchTerm, selectedRamo, selectedRubro, selectedSubrubro, selectedMarca, currentPage, perPage, ordenamiento);
  }, [searchTerm, selectedRamo, selectedRubro, selectedSubrubro, selectedMarca, currentPage, perPage, orderBy, empresa]);

  useEffect(() => {
    fetchCarrito();
  }, []);

  const handlePageChange = (event, value) => {
    setCurrentPage(value); // Actualizar la página actual
  };

  const handlePerPageChange = (event) => {
    setPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleOpenPdf =  async (format) => {

    const allProducts = await fetchAllProductsForPdf();
    const blob = await pdf(<ExportPdf products={allProducts} empresa={empresa} seccion={"Busqueda: " + searchQuery}  format={format}/>).toBlob();
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  };

  const toggleCartItem = (artId) => {
    const idCarrito = localStorage.getItem('idCarrito');  // Obtén el cartId del localStorage
    if (!idCarrito) {
      ////("No se ha encontrado un carrito asociado al cliente.");
      return;
    }

    // Verificamos si el carrito que estamos usando es el del cliente actual
    const exists = cartItems.find(item => item.cartId === idCarrito && item.artId === artId);

    if (exists) {
      // Si ya existe, lo eliminamos del carrito
      setCartItems(prev => prev.filter(item => item.cartId !== idCarrito || item.artId !== artId));
    } else {
      // Si no existe, lo agregamos al carrito
      setCartItems(prev => [
        ...prev,
        { cartId: Number(idCarrito), artId }  // Guardamos cartId y artId
      ]);
    }
  };
  if (loading) return <Loading message="Cargando busqueda..." />;
  return (
    <Grid container spacing={2} p={2} alignItems="center">
      <CategoryFilter
        selectedRamo={selectedRamo}
        setRamoX={setSelectedRamo}
        selectedRubro={selectedRubro}
        setRubroX={setSelectedRubro}
        rubrosArray={rubrosArray}
        setRubrosArray={setRubrosArray}
        selectedSubrubro={selectedSubrubro}
        setSubrubroX={setSelectedSubrubro}
        subrubrosArray={subrubrosArray}
        setSubrubrosArray={setSubrubrosArray}
        selectedMarca={selectedMarca}
        setMarcaX={setSelectedMarca}
      />
      <Grid container spacing={2} sx={{ mb: 2 }} justifyContent="center">
        {/* Cabecera con PDF y vista */}
        <ControlsRow
          isLogin={user?.id}
          products={products}
          generandoPDF={generandoPDF}
          setGenerandoPDF={setGenerandoPDF}
          handleOpenPdf={handleOpenPdf}
          viewMode={viewMode}
          setViewMode={setViewMode}
          orderBy={orderBy}
          setOrderBy={setOrderBy}
        />
      </Grid>
      <ProductList
        products={products}
        isCheckStock={empresa?.venta_sin_stock}
        viewMode={viewMode}
        totalPages={totalPages}
        currentPage={currentPage}
        perPage={perPage}
        totalItems={totalItems}
        handlePageChange={handlePageChange}
        handlePerPageChange={handlePerPageChange}
        cartItems={cartItems}
        toggleCartItem={toggleCartItem}
      />
    </Grid>
  );
};

export default SearchResults;
